module.exports = __webpack_public_path__ + "static/media/Leave.a9b66cfb.svg";